import { useEffect, useState } from 'react';
import { getAdminEntities } from '../api/paymentApi';

/** Entities with their nested spaces for the filter dropdowns. Not called at all when disabled. */
export function useAdminEntities(enabled) {
  const [state, setState] = useState({ entities: [], loading: Boolean(enabled), failed: false });

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true }));
    getAdminEntities()
      .then((data) => { if (!cancelled) setState({ entities: Array.isArray(data) ? data : [], loading: false, failed: false }); })
      .catch(() => { if (!cancelled) setState({ entities: [], loading: false, failed: true }); });
    return () => { cancelled = true; };
  }, [enabled]);

  return state;
}
